<template>
  <office-city-search-base
    :type="type"
    :submit-url="submitUrl"
    :i18n="i18n"
  >
    <template #city-select="{ onChange }">
      <city-select
        :i18n="{
          placeholder: i18n.cityPlaceholder,
          noResults: i18n.cityNoResults,
        }"
        @change="onChange"
      />
    </template>
  </office-city-search-base>
</template>

<script>
import OfficeCitySearchBase from './office-search-form-base.vue';
import props from './office-search-form-props';
import CitySelect from './city-select.vue';

export default {
  name: 'SearchForm',
  components: {
    CitySelect,
    OfficeCitySearchBase,
  },
  props,
};

</script>
